"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.profession.list': 'Professioni',
    'route.profession.create': 'Aggiungi Professione',
    'route.profession.edit': 'Modifica Professione',
};
